import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {EquipmentTypeDocumentTitle} from 'src/pages/Modules/Inspections/shared/equipmentTypeHelpers';
import {EquipmentTypeForm} from 'src/pages/Modules/Inspections/shared/EquipmentTypeForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const EquipmentTypeCreatePage = () => {
  useSetDocumentTitle(EquipmentTypeDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Inspections}>
      <EquipmentTypeForm mode="create" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.EquipmentTypesCreate(),
  element: <EquipmentTypeCreatePage />,
  module: ModuleEnum.Inspections,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
